/**
 * 卡牌相关工具函数
 */

import type { GameCard } from '../types';

/**
 * 计算需要弃掉的卡牌数量
 */
export const calculateDiscardCount = (
  deckSize: number, 
  pendingCount: number, 
  maxSize: number
): number => Math.max(0, deckSize + pendingCount - maxSize);

/**
 * 检查是否可以确认选牌
 */
export const canConfirmDraft = (selectedCount: number, maxSelect: number): boolean => 
  selectedCount > 0 && selectedCount <= maxSelect;

/**
 * 检查是否可以确认弃牌
 */
export const canConfirmDiscard = (needToDiscard: number, selectedCount: number): boolean => 
  needToDiscard > 0 && selectedCount === needToDiscard;

/**
 * 切换卡牌选择状态
 */
export const toggleCardSelection = (
  currentSelected: Set<string>,
  cardId: string,
  maxSelect?: number
): Set<string> => {
  const newSelected = new Set(currentSelected);
  if (newSelected.has(cardId)) {
    newSelected.delete(cardId);
  } else if (maxSelect === undefined || newSelected.size < maxSelect) {
    newSelected.add(cardId);
  }
  return newSelected;
};

/**
 * 从牌组中抽取卡牌到手牌
 */
export const drawCardsFromDeck = (
  deck: GameCard[],
  currentHand: GameCard[],
  drawCount: number = 3
): GameCard[] => {
  const availableCards = deck.filter(
    (d) => !currentHand.some((c) => c.id === d.id)
  );
  return availableCards.slice(0, drawCount);
};
